var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4640",
    "data-name": "Group 4640",
    transform: "translate(-1719.174 -261.594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5180",
    "data-name": "Group 5180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5179",
    "data-name": "Group 5179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5157",
    "data-name": "Group 5157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5156",
    "data-name": "Group 5156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5155",
    "data-name": "Group 5155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5185",
    "data-name": "Group 5185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6158",
    "data-name": "Path 6158",
    d: "M14,0A14,14,0,1,1,0,14,14,14,0,0,1,14,0Z",
    transform: "translate(1719.174 261.594)",
    fill: "#0a7da7"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5171",
    "data-name": "Group 5171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5170",
    "data-name": "Group 5170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5169",
    "data-name": "Group 5169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5168",
    "data-name": "Group 5168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5167",
    "data-name": "Group 5167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5166",
    "data-name": "Group 5166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5165",
    "data-name": "Group 5165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5164",
    "data-name": "Group 5164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M127.142,14.9h3.265V25.421h-3.265Zm1.633-5.2a1.874,1.874,0,1,1-1.874,1.874A1.884,1.884,0,0,1,128.774,9.7",
    transform: "translate(1598.337 256.785)",
    fill: "#fff"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5158",
    "data-name": "Group 5158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5163",
    "data-name": "Group 5163"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5162",
    "data-name": "Group 5162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5161",
    "data-name": "Group 5161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5160",
    "data-name": "Group 5160"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5159",
    "data-name": "Group 5159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5178",
    "data-name": "Group 5178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5177",
    "data-name": "Group 5177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5176",
    "data-name": "Group 5176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5175",
    "data-name": "Group 5175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5174",
    "data-name": "Group 5174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5173",
    "data-name": "Group 5173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5172",
    "data-name": "Group 5172"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M136.1,18.142h3.144v1.451h.06a3.384,3.384,0,0,1,3.084-1.693c3.326,0,3.93,2.177,3.93,5.019v5.744h-3.265V23.523c0-1.209,0-2.781-1.693-2.781s-1.935,1.33-1.935,2.721v5.2H136.16V18.142Z",
    transform: "translate(1594.727 253.556)",
    fill: "#fff"
  })))))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.59a7bfed1a2904db1e8073f7fd23cfa1.svg";
export { ForwardRef as ReactComponent };